/**
 * 依存クラス： Validator、SelectionValidator、InputValidator
 */
export class FormChecker
{
  /**
   * コンストラクタ
   * @param { instances[] } validators
   * @param { instances[] } formItemCheckers
   * @param { HTMLElement } form
   */
  constructor( validators, formItemCheckers, form ) {
    this.formItemCheckers    = formItemCheckers || false;
    this.validators          = validators || false;
    this.form                = form || false;
    this.counterEl           = form.querySelector( '.p-counter' ) || false;
    this.counterElNum        = form.querySelector( '.js-counterNum' ) || false;
    this.submitButtons       = form.querySelectorAll( 'input[type="submit"],input[type="button"]' ) || false;

    // フォームを送信不可にする
    this.form.sde_doubleSubmission_onsubmit_original = () => {
      return false;
    };
  }

  /**
   * 必須選択項目の数をHTMLに反映する
   * @returns { void }
   */
  reflectErrorNum = () =>
  {
    if ( this.counterElNum && this.formItemCheckers.length ) {
      let cnt = 0;
      this.formItemCheckers.forEach( formItemChecker => {
        if ( formItemChecker.validators.length && formItemChecker.getErrorCount() && formItemChecker.checkIcon ) {
          cnt++;
        }
      } );

      this.counterElNum.textContent = cnt;
    }
  }

  /**
   * フォーム全体をチェックして、エラーがなければ、送信可能にする
   * @returns { void }
   */
  checkAll = () =>
  {
    let cnt = 0;
    this.validators.forEach( validator => {
      if ( validator.errorCount > 0 ) {
        cnt++;
      }
    } );
    this.formItemCheckers.forEach( formItemChecker => {
      if ( formItemChecker.getErrorCount() ) {
        cnt++;
      }
    } );

    if ( cnt === 0 ) {
      this.form.sde_doubleSubmission_onsubmit_original = () => {
        return true;
      };
      this.submitButtons.forEach( item => {
        item.removeAttribute( 'disabled' );
      } );
    } else {
      this.form.sde_doubleSubmission_onsubmit_original = () => {
        return false;
      };
      this.submitButtons.forEach( item => {
        item.setAttribute( 'disabled', null );
      } )
    }
  }
}
